export default __webpack_public_path__ + "static/media/foochia.652d20cc.png";